import { render, staticRenderFns } from "./ManageVulnerabilities.vue?vue&type=template&id=aaa319fa&"
import script from "./ManageVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./ManageVulnerabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports